// extracted by mini-css-extract-plugin
export default {"card":"card__EkrC7kQK","footerContainer":"footerContainer__u3l6ZVGA","submitButton":"submitButton__kurd1nHI"};